import './Akutrutan.scss'
import React, { Fragment, useCallback, useEffect, useState } from 'react'
import { useAkutrutanQuery } from '../../hooks/useAkutrutanQuery'
import closeIcon from '../../images/close-icon.svg'
import { Link } from '../global'

const Akutrutan = ({ setIsAkutrutaActive }) => {
  const { allWpAkutrutanSetting } = useAkutrutanQuery()
  const [showAkutrutan, setShowAkutrutan] = useState(null) // [bool,date]

  const data = allWpAkutrutanSetting?.edges[0]

  const updateShowAkutrutan = useCallback(
    (_, show) => {
      if (typeof window !== 'undefined') {
        const updatedShowAkutrutan = show ? [true] : [false, data.node.date]
        setIsAkutrutaActive(show ? true : false)
        setShowAkutrutan(updatedShowAkutrutan) // modify "desktop-menu" height

        window.localStorage.setItem(
          'showTheAkutruta',
          JSON.stringify(updatedShowAkutrutan),
        )
      }
    },
    [setIsAkutrutaActive, setShowAkutrutan, data],
  )

  const updateShowAkutrutanCallback = useCallback(
    localStorage => {
      if (!showAkutrutan) {
        if (!localStorage) updateShowAkutrutan(null, true)

        if (localStorage && !localStorage[1]) updateShowAkutrutan(null, true)

        if (localStorage && localStorage[1]) {
          const date = localStorage[1]

          // Change data.node.date to .modifiedDate and update query if optionPage works
          if (date !== data?.node.date) updateShowAkutrutan(null, true)
          else {
            setShowAkutrutan(localStorage)
            setIsAkutrutaActive(localStorage[0])
          }
        }
      }
    },
    [
      data,
      showAkutrutan,
      setIsAkutrutaActive,
      setShowAkutrutan,
      updateShowAkutrutan,
    ],
  )

  useEffect(() => {
    const localStorage = JSON.parse(
      window.localStorage.getItem('showTheAkutruta'),
    )

    updateShowAkutrutanCallback(localStorage)
  }, [updateShowAkutrutanCallback])

  return (
    <Fragment>
      {showAkutrutan &&
        showAkutrutan[0] &&
        data?.node?.AkutrutanSettings?.showAkutrutan && (
          <div
            className={`akutrutan-container ${data.node.AkutrutanSettings.color}`}
          >
            <div className="innerContainer">
              <div className="info-block">
                {data.node.AkutrutanSettings.pageLinkCheckbox &&
                data.node.AkutrutanSettings.pageLink?.url ? (
                  <Link to={data.node.AkutrutanSettings.pageLink.url}>
                    <p className="info-text">
                      {data.node.AkutrutanSettings.infoText}
                      {' - '}
                      <span className="link">Läs mer</span>
                    </p>
                  </Link>
                ) : (
                  <p className="info-text">
                    {data.node.AkutrutanSettings.infoText}
                  </p>
                )}

                <span className="date">
                  {data.node.AkutrutanSettings.datePicker}
                </span>
              </div>

              <button
                className="icon-button close"
                onClick={updateShowAkutrutan}
              >
                <img alt="close icon" src={closeIcon} />
              </button>
            </div>
          </div>
        )}
    </Fragment>
  )
}

export default Akutrutan
